import { TotalStats } from "../components/PSY/TotalStats";
import { Prices } from "../components/PSY/Prices";
import { NoTrove } from "../components/Trove/NoTrove";
import { MyTroves } from "../components/Trove/PSY/MyTroves";
import { NoDeposit } from "../components/Stability/NoDeposit";
import { MySpPositions } from "../components/Stability/PSY/MySpPositions";
import { SystemStats } from "../components/SystemStats";
import { LiquityStoreState, StabilityDeposit, UserTrove } from "@liquity/lib-base"
import { useLiquitySelector } from "@liquity/lib-react";
import { merge, isEmpty } from "lodash";

const select = ({ collateralStates, collateralDerivedStates }: LiquityStoreState) => {
  const collStates = merge(collateralStates, collateralDerivedStates)

  const selected = Object.entries(collStates)
    .reduce<{ userTroves: UserTrove[], spDeposits: StabilityDeposit[] }>((acc, [key, value]) => {
    const { trove, stabilityDeposit } = value
    if (trove.status === "open" || trove.status === "closedByLiquidation" ) {
      acc.userTroves.push(trove)
    }
    if (!stabilityDeposit.isEmpty) {
      acc.spDeposits.push(stabilityDeposit)
    }
    return acc
  }, { userTroves: [], spDeposits: [] })
  return selected
};

export const Dashboard: React.FC = () => {
  const { userTroves, spDeposits} = useLiquitySelector(select);
  return(
    <>
      <div className="flex flex-col md:flex-row gap-5 w-full h-full md:mt-6">
        <div className="flex flex-col gap-5 md:w-3/5">
          <TotalStats />
          <div className="flex md:hidden">
            <Prices />
          </div>
          <div className="">
            {isEmpty(userTroves) ? (
              <NoTrove />
            ) : (
              <MyTroves />
            )}
          </div>
          <div className="">
            {isEmpty(spDeposits) ? (
              <NoDeposit />
            ) : (
              <MySpPositions />
            )}
          </div>
        </div>
        <div className="flex flex-col gap-5 md:w-2/5">
          <div className="hidden md:flex">
            <Prices />
          </div>
          <div className="">
            <SystemStats />
          </div>
        </div>
      </div>
    </>
  )
};
